import Icon from '../components/Icon.vue'

Icon.register({"gg-circle":{"width":1792,"height":1792,"paths":[{"d":"M717 1354l271-271-279-279-88 88 192 191-96 96-279-279 279-279 40 40 87-87-127-128-454 454zM1075 1346l454-454-454-454-271 271 279 279 88-88-192-191 96-96 279 279-279 279-40-40-87 88zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/gg-circle.js